import { useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";

import { closeConfirmModal, openConfirmModal } from "actions";

import { SideLoadedDataSetAction } from "actions/sideLoadedData";

import { selectSideLoadedDataSetLabelsById } from "selectors";

export type DeleteSideLoadedDataSet = (dataSet: SideLoadedDataSet) => void;

export function useDeleteSideLoadedDataSet(): DeleteSideLoadedDataSet {
  const dispatch = useDispatch();
  // The label, not the name - deleting is destructive, so the prompt has to name
  // which of two same-named data sets is about to go.
  const labelsById = useSelector(selectSideLoadedDataSetLabelsById);

  return useCallback(
    (dataSet: SideLoadedDataSet) => {
      dispatch(
        openConfirmModal({
          title: "Are you sure?",
          message: `Deleting "${labelsById[dataSet.id] || dataSet.name}" will remove its ${dataSet.recordCount.toLocaleString()} records from the Legacy Data tab.`,
          actions: [
            {
              label: "Cancel",
              onClick: () => dispatch(closeConfirmModal()),
              secondary: true,
            },
            {
              label: "Delete Data",
              onClick: () => {
                dispatch(SideLoadedDataSetAction.delete(dataSet.id));
                dispatch(closeConfirmModal());
              },
              secondary: false,
            },
          ],
        }),
      );
    },
    [dispatch, labelsById],
  );
}
